export default __webpack_public_path__ + "static/feature-b485da541554e554e55d96dbc17a85d8.gif";